import { UtilService } from 'src/app/core/services/util/util.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';

// import { saveAs } from 'file-saver-es';
import { Content } from './content/content';
import { AppGlobalsModule } from './app-globals.module';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class DownloadService implements OnDestroy {
    private http = inject(HttpClient);
    private _utils = inject(UtilService);

    subscribes: Subscription[] = [];
    downloadAllFiles(lessons: Content[]) {
        // let link = document.createElement('a');
        //     link.setAttribute('download', '');
        //     link.setAttribute('target', '_blank');
        //     link.style.display = 'none';
        //     document.body.appendChild(link);

        // this.downloadFile("filename.mp3");
        // this.downloadFile("‏‏filename1.mp3");

        lessons.forEach((element) => {
            if (element.Audio) {
                // let url = AppGlobalsModule.mediaPath() + element.Filename[0] +"/" + element.Filename + ".mp3";
                // link.setAttribute('href', url);
                // link.click();
                this.downloadFile(element);
            }
        });
        // document.body.removeChild(link);
    }

    downloadFile(lesson: Content) {
        let downloadUrl = AppGlobalsModule.mediaPath() + lesson.Filename[0] + '/' + lesson.Filename + '.mp3';
        //let downloadUrl = "/content/local-media/" + lessonFile;
        let headers = new HttpHeaders({ 'Content-Type': 'audio/mpeg', Accept: 'audio/*' });
        this.subscribes.push(
            this.http.get(downloadUrl, { headers: headers, responseType: 'blob' }).subscribe((result) => this.extractContent(result, lesson.Filename, 'mp3')),
        );
    }

    public directDownloadAudio(downloadUrl: string) {
        // saveAs('blob:' + downloadUrl);
    }

    private extractContent(blob: Blob, name: string, ext: string) {
        // saveAs(blob, name + '.' + ext);
    }

    ngOnDestroy(): void {
        this._utils.unsubscribe(this.subscribes);
    }
}
